import { ADDRESS_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const cook = new Cookies().get("loginData1");

const headersdata = {
  "content-type": "application/json",
  Accept: "application/json",
  Authorization: cook != undefined ? cook.accessToken : "",
  // 'Authorization': url.Auth_Token
};


export const addNewAddress = (id,data) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .post(ADDRESS_URL() +id, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject("Error in addNewAddress axios!");
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};


